/* get data */
export const GET_SHORTLIST_DETAILS = "GET_SHORTLIST_DETAILS";
export const GET_SHORTLIST_DETAILS_SUCCESS = "GET_SHORTLIST_DETAILS_SUCCESS";
export const GET_SHORTLIST_DETAILS_FAIL = "GET_SHORTLIST_DETAILS_FAIL";
// shortlist manager list
export const GET_SHORTLIST_MANAGERS_LIST = "GET_SHORTLIST_MANAGERS_LIST";
export const GET_SHORTLIST_MANAGERS_LIST_SUCCESS =
  "GET_SHORTLIST_MANAGERS_LIST_SUCCESS";
export const GET_SHORTLIST_MANAGERS_LIST_FAILED =
  "GET_SHORTLIST_MANAGERS_LIST_FAILED";
// add new shortlist manager
export const ADD_SHORTLIST_MANAGER = "ADD_SHORT_LIST_MANAGER";
export const ADD_SHORTLIST_MANAGER_SUCCESS = "ADD_SHORTLIST_MANAGER_SUCCESS";
export const ADD_SHORTLIST_MANAGER_FAILURE = "ADD_SHORTLIST_MANAGER_FAILURE";
//change shortlist manager
export const CHANGE_SHORTLIST_MANAGER = "CHANGE_SHORTLIST_MANAGER";
export const CHANGE_SHORTLIST_MANAGER_SUCCESS =
  "CHANGE_SHORTLIST_MANAGER_SUCCESS";
export const CHANGE_SHORTLIST_MANAGER_FAILURE =
  "CHANGE_SHORTLIST_MANAGER_FAILURE";

// Update shortlist details (move to interview/reject)
export const UPDATE_SHORTLIST_DETAILS = "UPDATE_SHORTLIST_DETAILS";
export const UPDATE_SHORTLIST_DETAILS_SUCCESS =
  "UPDATE_SHORTLIST_DETAILS_SUCCESS";
export const UPDATE_SHORTLIST_DETAILS_FAIL = "UPDATE_SHORTLIST_DETAILS_FAIL";
